/**
 * Positions Catalog Service
 */

import { apiClient } from '@/api/core/apiClient.ts';
import { API_CONFIG } from '@/api/core/apiConfig.ts';
import type { ApiResponse } from '@/api/shared/types.ts';
import type { LC_GetPositionsOut, Position } from './positions.types.ts';
import { mapPositionOutToModel } from './positions.mapper.ts';


export class PositionsCatalogService {
  /**
   * Get available positions for the authenticated user's company.
   * @param areaIds - Optional comma-separated list of area IDs (e.g. "1,22,33").
   *                 Pass a single ID as a string ("5") for single-area filtering.
   */
  async getPositions(areaIds?: string): Promise<ApiResponse<Position[]>> {
    const endpoint = API_CONFIG.ENDPOINTS.CATALOG.POSITIONS(areaIds);
    const response = await apiClient.get<LC_GetPositionsOut>(endpoint);

    if (response.success && response.data) {
      return {
        ...response,
        data: response.data.map(mapPositionOutToModel),
      };
    }

    return { ...response, data: null };
  }
}

export const positionsCatalogService = new PositionsCatalogService();
